import { useTranslation } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import { emitNotification } from "@impero-com/ui";
import { AxiosError } from "axios";

import { usePostControls } from "api/generated/controls/controls";
import { CreateControlsErrorPayload } from "api/generated/model";
import { STATUS_CODE_ERROR_OPERATION_FAILED } from "utils/errorCodes";

import { getMoneyTaskErrorMessage } from "../utils/moneyTaskErrorMessage";

export function useCreateControlMutation() {
    const { t } = useTranslation();
    return usePostControls({
        mutation: {
            onError: (error: AxiosError<CreateControlsErrorPayload>) => {
                if (
                    error.response?.status !==
                    STATUS_CODE_ERROR_OPERATION_FAILED
                ) {
                    emitNotification(
                        "error",
                        t("CreateControl_Submit_ServerError")
                    );
                    return;
                }
                const details = error.response.data;
                switch (details.type) {
                    case "InvalidAutoCompletion":
                        emitNotification(
                            "error",
                            t("CreateControl_Submit_InvalidAutoCompletionError")
                        );
                        break;
                    case "InvalidMoneyTask":
                        emitNotification(
                            "error",
                            getMoneyTaskErrorMessage(t, details.error),
                            { duration: "DOUBLE" }
                        );
                        break;
                    default:
                        assertNever(details);
                }
            },
        },
    });
}
